import { getFullUrl } from 'hubspot-url-utils';
export const getUserIdsFromComment = message => {
  const matchedResult = message.match(/data-mention-id="[0-9]+/gi);
  if (!matchedResult) return [];
  return matchedResult.map(el => el.split('="').pop() || '').filter(item => item);
};
export const getCtaUrl = ({
  portalId,
  callObjectId
}) => `${getFullUrl('app')}/calls/${portalId}/review/${callObjectId}`;
export const sortComments = comments => comments.sort((a, b) => a.createdAt - b.createdAt);
export const sortSnippetResults = ({
  response,
  query
}) => {
  const snippets = response.results;
  try {
    snippets.sort((a, b) => {
      const ashort = (a.shortcut || a.name).trim().toLowerCase();
      const bshort = (b.shortcut || b.name).trim().toLowerCase();
      const tLower = query.trim().toLowerCase();
      if (ashort.startsWith(tLower) && bshort.startsWith(tLower)) {
        return ashort.length - bshort.length;
      } else if (ashort.startsWith(tLower)) {
        return -1;
      } else if (bshort.startsWith(tLower)) {
        return 1;
      }
      return 0;
    });
    response.results = snippets;
  } catch (e) {
    console.error(e);
  }
  return response;
};